import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from 'react';
import {GetVehicleDetailById} from '../../../../reduxToolkit/Contractor/ContractorApi';
import {GetProviderVehicleStatus} from '../../../../reduxToolkit/Providers/providersApi';
import {DeleteItemsApi} from '../../../../reduxToolkit/Commons/CommonsApi';
import routes from '../../../../Routes/routes';
import {TABLES} from "../../../../Apis/Tables";

const VehicleContractDetailApp = () => {

    const { t } = useTranslation();
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // use Selector
    const { updateProviderVehicleData, saveProviderVehicleImage } = useSelector((state) => state?.providersSlice);
    const { uploadImage, changeCount } = useSelector((state) => state.sharedSlice);
    const { getVehicleDetailById, setToExternalVehicle, createToExternalVehicle } = useSelector((state) => state?.ContractorSlice);

    // use State
    const [selectDocumentsForDelete, setSelectDocumentsForDelete] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [deleteDocShow, setDeleteDocShow] = useState(false);
    const [unlinkShow, setUnlinkShow] = useState(false);
    const [deletedFlag, setDeletedFlag] = useState(0);
    const [deleteVehicleShow, setDeleteVehicleShow] = useState(false);
    const [selectVehicleForDelete, setSelectVehicleForDelete] = useState();

    /**
     * Fetch the details of a vehicle
     */
    useEffect(() => {
        dispatch(GetVehicleDetailById(params?.id)).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setSelectVehicleForDelete([data.vehicle.id]);
                }
            },
        );
    }, [
        updateProviderVehicleData,
        createToExternalVehicle,
        setToExternalVehicle,
        saveProviderVehicleImage,
        deletedFlag,
        uploadImage,
        changeCount,
    ]);

    /**
     * Fetch vehicle status information
     */
    useEffect(() => {
        dispatch(GetProviderVehicleStatus());
    }, []);

    /**
     * @param deleteItem
     * Vehicle document deletion API
     */
    const deleteSelectedDocuments = (deleteItem) => {
        const tableName = TABLES.CONTRACTOR_VEHICLE_DOCUMENT;
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                     payload: {
                         data: { success },
                     },
                 }) => {
                    if (success === true) {
                        setDeletedFlag(deletedFlag + 1);
                        setSelectDocumentsForDelete([]);
                        setIsAllChecked(false);
                    }
                },
            );
        }
    };

    /**
     * @param deleteItem
     * contractor vehicle deletion API
     */
    const deleteSelectedElement = (deleteItem) => {
        const tableName = TABLES.CONTRACTOR_VEHICLE;
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName, body })).then(
                ({
                     payload: {
                         data: { success },
                     },
                 }) => {
                    if (success === true) {
                        navigate(routes.vehicleContractor.search);
                    }
                },
            );
        }
    };

    return {
        t, params,
        navigate,
        dispatch,
        deleteSelectedElement,
        deleteSelectedDocuments,
        selectDocumentsForDelete, setSelectDocumentsForDelete,
        isAllChecked, setIsAllChecked,
        deleteDocShow, setDeleteDocShow,
        unlinkShow, setUnlinkShow,
        deletedFlag, setDeletedFlag,
        deleteVehicleShow, setDeleteVehicleShow,
        selectVehicleForDelete, setSelectVehicleForDelete,
        getVehicleDetailById
    }

}

export default VehicleContractDetailApp;
